require('./accountSettingsController');
require('../fhApp/currentUser/subscriptionStatus/subscriptionStatusDirective');

"use strict";

angular.module('app.accountSettings', [
    'app.accountSettings.accountSettingsController',
    'app.currentUser.subscriptionStatus.subscriptionStatusDirective'
])
.config([
    '$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('app.accountSettings', {
            url: '/account',
            templateUrl: 'components/accountSettings/accountSettingsView.html',
            controller: 'app.accountSettings.accountSettingsController',
            title: 'Account Settings',
            params: {
              redirect_url: null,
              redirect_params: null,
            },
        })
    }
]);


// WEBPACK FOOTER //
// ./app.v2/components/accountSettings/accountSettings.js